<template>
  <p v-if="hasError" class="text-danger">{{ errorDescription }}</p>
</template>
<script>
import * as inputErrorHandler from '@/utils/validation/inputErrorHandler'

export default {
  name: 'VErrorResponce',

  props: {
    error: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    hasError () {
      return inputErrorHandler.hasError(this.error)
    },
    errorDescription () {
      return inputErrorHandler.getErrorDescription(this.error)
    }
  }
}
</script>
